<template>
  <v-main>
    <v-container
        class="fill-height"
        fluid
    >
      <v-row
          align="center"
          justify="center"
      >
        <v-col
            cols="12"
            md="6"
        >
          <v-alert
              icon="mdi-shield-lock-outline"
              prominent
              text
              type="info"
          >
            <v-row align="center">
              <v-col class="grow">
                <h3 class="headline mb-1">404 — page not found</h3>
                The page you are looking for doesn't exist or you don't have
                access to it.
              </v-col>
              <v-col class="shrink">
                <v-btn color="primary" elevation="0" @click="go_to_login">
                  Go to login
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "PageNotFound",
  methods: {
    go_to_login() {
      let self = this;
      self.$router.push('/login');
    },
  }
}
</script>

<style scoped>

</style>